import React from 'react';
import { Menu, Popover, Position, Avatar, CaretRightIcon } from 'evergreen-ui';
import TruncatedText from 'components/UI/TruncatedText';
import TabItem from '../TabItem';
import { getFullName } from 'resources/user/user.helpers';
import styles from './styles.module.scss';


const AccountMenu = ({ tabs, disabled, user, company }) => {
  if (!user) return null;
  
  const popoverRef = React.createRef();

  const closeMenu = () => {
    if (popoverRef.current) popoverRef.current.close();
  }

  const renderTabItems = () => tabs.map((tab) => (
    <TabItem key={tab.label} tab={tab} disabled={disabled} user={user} company={company} closeMenu={closeMenu} />
  ));

  return (
    <div>
      <Popover
        position={Position.RIGHT}
        ref={popoverRef}
        content={(
          <div className={styles.accountMenu}>
            <Menu>
              <Menu.Group title="My Account"></Menu.Group>
              {renderTabItems()}
            </Menu>
          </div>
        )}
      >
        <div className={styles.userMenu}>
          <Avatar
            src={user.avatar_url}
            name={getFullName(user)}
            size={26}
          />

          <TruncatedText variant="p" className={styles.userName}>
            {getFullName(user)}
          </TruncatedText>

          <CaretRightIcon size={16} />
        </div>
      </Popover>
    </div>
  );
};

export default React.memo(AccountMenu);
